import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
} from "@mui/material";
import useUpdate from "../../api/useUpdate";
import { useTranslation } from "react-i18next";

const CurrencyEdit = ({ open, onClose, editData, token }) => {
  const { t } = useTranslation();
  const { handleUpdate, loading, isSuccess } = useUpdate(
    "shop/currencies",
    token
  );
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (editData) {
      setTitle(editData.title || "");
      setDescription(editData.description || "");
    }
  }, [editData]);

  const handleSubmit = () => {
    const payload = {
      title: title.trim(),
      description: description.trim(),
    };
    handleUpdate(editData.id, payload);
  };

  useEffect(() => {
    if (isSuccess) {
      setTitle("");
      setDescription("");
      onClose();
    }
  }, [isSuccess, onClose]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("currency.editCurrency")}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            autoFocus
            margin="dense"
            label={t("currency.title")}
            type="text"
            fullWidth
            required
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField
            margin="dense"
            label={t("currency.description")}
            type="text"
            fullWidth
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {t("currency.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading || !title.trim()}
          sx={{ minWidth: 100 }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            t("currency.submit")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CurrencyEdit;
